import { TableName } from '@/enums/tableName.enum';
import { Filter } from '@/interfaces/filters/filter';
import { SchedulesContainerObjectType } from '@/interfaces/schedulesContainerObjectType';
import { ScheduleResource, scheduleResource } from '@/resources/schedule.resource';
import { EntityModule } from './entity.module';
/**
 * Moduł harmonogramów
 *
 * @export
 * @class ScheduleModule
 * @extends {EntityModule<SchedulesContainerObjectType, ScheduleResource>}
 */
export class ScheduleModule extends EntityModule<SchedulesContainerObjectType, ScheduleResource> {
  constructor() {
    super(scheduleResource);
    this.state = {
      ...this.state,
      data: {
        entityType: undefined,
        entityId: undefined
      }
    };
    this.actions = {
      ...this.actions,
      /**
       * Pobiera listę encji
       *
       * @param context context
       * @param filters filtry listy
       */
      list: async (context: any, filters: Filter): Promise<void> => {
        const pagination = {
          ...filters,
          entityId: context.rootState.schedule.data.entityId,
          entityType: context.rootState.schedule.data.entityType
        };
        const { list, count } = await this.resource.list(pagination);
        context.commit('saveList', list);
        context.commit('saveCount', count);
      },
      /**
       * Pobiera harmonogram po encji
       *
       * @param context context
       * @param data
       */
      getByEntity: async (context: any, data: { entityId: string; entityType: string }): Promise<void> => {
        const { list, count } = await this.resource.list({
          count: 1,
          entityId: data.entityId,
          entityType: data.entityType
        } as Filter);
        context.commit('saveCount', count);
        if (count) {
          await context.dispatch('get', list[0].id);
        }
      }
    };
    this.mutations = {
      ...this.mutations,
      /**
       * Ustawia rodzaj encji
       *
       * @param {*} localState
       * @param {TableName} entityType
       */
      setEntityType(localState: any, entityType: TableName): void {
        localState.data.entityType = entityType;
      },
      /**
       * Ustawia id encji
       *
       * @param {*} localState
       * @param {number} entityId
       */
      setEntityId(localState: any, entityId: number): void {
        localState.data.entityId = entityId;
      }
    };
  }
}

export default new ScheduleModule();
